import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Logo } from "@rescuetablet/theme";
import { useCallback, useState, type FormEvent } from "react";

export default function SignIn({
  error,
  signIn,
}: {
  error?: any;
  signIn: (apiKey: string) => void;
}) {
  const [apiKey, setApiKey] = useState("");

  const onSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      console.log("signing in:", apiKey);
      signIn(apiKey);
    },
    [apiKey, signIn]
  );

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "30rem",
        maxWidth: "90%",
      }}
    >
      <Card>
        <form onSubmit={onSubmit}>
          <Box sx={{ bgcolor: "secondary.main", p: 2 }}>
            <Box component={Logo} sx={{ color: "white", width: "50%" }} />
          </Box>
          <CardContent>
            <Stack spacing={2}>
              <Typography>Bitte melden Sie sich an.</Typography>
              <TextField
                label="API-Key"
                value={apiKey}
                onChange={(e) => setApiKey(e.currentTarget.value)}
              />
              {error && (
                <Alert severity="error">Fehler bei der Anmeldung.</Alert>
              )}
            </Stack>
          </CardContent>
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              type="submit"
              disabled={!apiKey}
            >
              Anmelden
            </Button>
          </CardActions>
        </form>
      </Card>
    </Box>
  );
}
